import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";
import DteSystemStatusPanel from "../../components/DteSystem/DteSystemStatusPanel";

const DteSystemStatusPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <DteSystemStatusPanel />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default DteSystemStatusPage;
